import { createStyles, Theme } from '@material-ui/core/styles';

import { colours } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    '@keyframes spin': {
      to: { transform: 'rotate(360deg)' },
    },
    root: {
      alignItems: 'flex-start',
      background: colours.solid.white,
      borderBottom: `1px solid ${colours.neutral[200]}`,
      display: 'flex',
      gap: 8,
      padding: 16,
      textAlign: 'left',
      width: '100%',
    },
    clickable: {
      cursor: 'pointer',
      '&:hover': {
        background: colours.neutral[50],
      },
      '&:focus-visible': {
        background: colours.neutral[50],
        outline: `2px solid ${colours.brandNavy[300]}`,
        outlineOffset: -2,
      },
    },
    main: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      gap: 12,
      minWidth: 0,
    },
    text: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      wordBreak: 'break-word',
    },
    textActioned: {
      '& $title': {
        color: colours.neutral[500],
      },
      '& $message': {
        color: colours.neutral[400],
      },
      '& $subtext': {
        color: colours.neutral[300],
      },
      '& $time': {
        color: colours.neutral[300],
      },
    },
    title: {
      color: colours.neutral[900],
      display: '-webkit-box',
      fontSize: 14,
      fontWeight: 600,
      lineHeight: '20px',
      overflow: 'hidden',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 2,
    },
    message: {
      color: colours.neutral[600],
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '20px',
    },
    subtext: {
      color: colours.neutral[500],
      fontSize: 13,
      fontWeight: 400,
      lineHeight: '18px',
    },
    time: {
      color: colours.neutral[400],
      fontSize: 12,
      fontWeight: 400,
      lineHeight: '18px',
    },
    actions: {
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'wrap',
      gap: 8,
    },
    pendingButton: {
      alignItems: 'center',
      background: colours.neutral[100],
      borderRadius: 6,
      color: colours.neutral[600],
      cursor: 'default',
      display: 'inline-flex',
      fontSize: 12,
      fontWeight: 600,
      gap: 6,
      lineHeight: '18px',
      padding: spacing(1.25, 2.5),
    },
    spinner: {
      animation: '$spin 0.7s linear infinite',
      border: `2px solid ${colours.neutral[300]}`,
      borderRadius: '50%',
      borderTopColor: colours.neutral[600],
      height: 12,
      width: 12,
    },
    statusBar: {
      alignItems: 'center',
      background: colours.neutral[50],
      borderRadius: 6,
      display: 'flex',
      gap: 8,
      justifyContent: 'space-between',
      padding: spacing(2, 2.5),
    },
    statusLeft: {
      alignItems: 'center',
      display: 'flex',
      gap: 8,
      minWidth: 0,
    },
    statusIconError: {
      color: colours.error[500],
      display: 'inline-flex',
      flexShrink: 0,
      // MUI's SvgIcon sets fill: currentColor in CSS, which beats the glyph's own
      // fill="none" attribute and fills this stroke-only tick into a solid blob.
      '& svg': {
        fill: 'none',
      },
    },
    statusText: {
      color: colours.neutral[700],
      fontSize: 13,
      lineHeight: '18px',
    },
    dismiss: {
      alignSelf: 'flex-start',
      flexShrink: 0,
    },
  });
